

import React, { memo, useState } from 'react';

import cx from 'classnames';
import { FormModal, Button } from '../../../ui-kit';
import '../styles/_confirm-modal.scss';














function handleSave(setSaving, onSave) {
  return async () => {
    setSaving(true);

    try {
      await onSave();
    } catch (e) {

      // Silent
    } finally {setSaving(false);
    }
  };
}

function ConfirmationModal({
  visible,
  onClose,
  hideSaveBtn = false,
  hideCancelBtn = false,
  onSave,
  title,
  subtitle,
  saveBtnText,
  className,
  children
}) {
  const [saving, setSaving] = useState(false);

  return (
    <div className={cx('confirm-modal', className)}>
      <FormModal
        visible={visible}
        onClose={onClose}
        title={title}
        subtitle={subtitle}
        hideFooter>

        {children}

        {!hideSaveBtn &&
        <Button
          className="confirm-modal__btn"
          onClick={handleSave(setSaving, onSave)}
          busy={saving}>

            {saveBtnText}
          </Button>}


        {!hideCancelBtn && onClose &&
        <Button
          type="TERTIARY"
          className="confirm-modal__cancel-btn"
          onClick={onClose}>

            Cancel
          </Button>}

      </FormModal>
    </div>);

}

ConfirmationModal.defaultProps = {
  saveBtnText: 'Ok'
};

export default memo(ConfirmationModal);